import React, { useEffect, useState } from "react";
import { useWindowSize } from "../../../utils";
export function useTruncatedList(ref) {
    const { width  } = useWindowSize();
    const [hiddenElements, setHiddenElements] = useState(0);
    useEffect(()=>{
        if (!ref.current) return;
        const listElements = getListElements(ref.current);
        const listWidth = ref.current.offsetWidth;
        const elements = hideElementsThatNotFit(listElements, listWidth);
        setHiddenElements(elements.hiddenElements);
    }, [
        width
    ]);
    function getListElements(list) {
        return Array.from(list.querySelectorAll("li"));
    }
    function hideElementsThatNotFit(elements, containerWidth) {
        return elements.reduce((acc, el)=>{
            const nextTagsWidth = acc.tagsWidth + el.offsetWidth;
            let nextHiddenElements = acc.hiddenElements;
            if (nextTagsWidth + 120 > containerWidth) {
                el.style.position = "absolute";
                el.style.opacity = "0";
                nextHiddenElements++;
            } else {
                el.removeAttribute("style");
            }
            return {
                tagsWidth: nextTagsWidth,
                hiddenElements: nextHiddenElements
            };
        }, {
            tagsWidth: 0,
            hiddenElements: 0
        });
    }
    return {
        hiddenElements
    };
}
